(function () {
  'use strict';

  angular.module('app.youtubePostOverview', ['ui.router'])

    .config(['$stateProvider', function ($stateProvider) {
      $stateProvider
        .state('home.youtubePostOverview', {
          requireLogin: true,
          url: 'youtubePostOverview/:url/:relativepath',
          templateUrl: 'app/youtubePostOverview/index.html?app_v=deployDate',
          scope: {},
          data: {
            authorizedRoles: ['Administrator', 'User', 'Achoo Analyst'],
            navMarker: ['youtubePostOverview', 'index']
          },
          controller: 'youtubePostOverviewCtrl',
          controllerAs: 'vm',
          params: {
              url: null,
              relativepath: null
          }
        })
    }]);
})();